import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button'; 
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [CommonModule,
    MatDialogModule,   
    MatButtonModule,],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>) { }

 
}
